import { default as _404dHtdFZ0cdIMeta } from "/Users/air/Projects/EMCI/pages/404.vue?macro=true";
import { default as _91titleA_93_45_91idA_93oECcRJDOEuMeta } from "/Users/air/Projects/EMCI/pages/actualites/[titleA]-[idA].vue?macro=true";
import { default as indexmohN8whQqyMeta } from "/Users/air/Projects/EMCI/pages/actualites/index.vue?macro=true";
import { default as indexH9tYCkiSiPMeta } from "/Users/air/Projects/EMCI/pages/bilan_competences/index.vue?macro=true";
import { default as index3S8ZaVGDi8Meta } from "/Users/air/Projects/EMCI/pages/bilan_competences/nos_centres/index.vue?macro=true";
import { default as indexLBz9lz85y0Meta } from "/Users/air/Projects/EMCI/pages/conseil_rh/entretien_annuel_professionnel/index.vue?macro=true";
import { default as indexvMavDzZDLdMeta } from "/Users/air/Projects/EMCI/pages/conseil_rh/gepp/index.vue?macro=true";
import { default as indexq0RQ2ACBOYMeta } from "/Users/air/Projects/EMCI/pages/conseil_rh/marque_employeur/index.vue?macro=true";
import { default as indexvN287DYUDXMeta } from "/Users/air/Projects/EMCI/pages/conseil_rh/obligations_legales/index.vue?macro=true";
import { default as indexfXbaWwtpOUMeta } from "/Users/air/Projects/EMCI/pages/conseil_rh/pcrh/index.vue?macro=true";
import { default as indexmFdL6yKwYlMeta } from "/Users/air/Projects/EMCI/pages/contactez-nous/index.vue?macro=true";
import { default as cookiesss7r5URXDyXMMeta } from "/Users/air/Projects/EMCI/pages/cookiesss.vue?macro=true";
import { default as index3dlahpNIjQMeta } from "/Users/air/Projects/EMCI/pages/equipe-bilan-competences/index.vue?macro=true";
import { default as indexKLybyXw6PPMeta } from "/Users/air/Projects/EMCI/pages/equipe/index.vue?macro=true";
import { default as indexqkbRkM2wFRMeta } from "/Users/air/Projects/EMCI/pages/formulaire-reclamation/index.vue?macro=true";
import { default as index167DsKZ6tGMeta } from "/Users/air/Projects/EMCI/pages/fr/index.vue?macro=true";
import { default as indexcW5UqQae4XMeta } from "/Users/air/Projects/EMCI/pages/index.vue?macro=true";
import { default as indexH5m0zDvIkiMeta } from "/Users/air/Projects/EMCI/pages/leadership-management/index.vue?macro=true";
import { default as indexUo0fj3d3eHMeta } from "/Users/air/Projects/EMCI/pages/management/accompagnement_codir/index.vue?macro=true";
import { default as indexinMpEVHefiMeta } from "/Users/air/Projects/EMCI/pages/management/co_developpement/index.vue?macro=true";
import { default as indexKBihwFAi24Meta } from "/Users/air/Projects/EMCI/pages/management/coaching_professionnel/index.vue?macro=true";
import { default as indexutVsgMraT4Meta } from "/Users/air/Projects/EMCI/pages/management/conduite_du_changement/index.vue?macro=true";
import { default as indexMYh0BlP7dZMeta } from "/Users/air/Projects/EMCI/pages/management/team_building/index.vue?macro=true";
import { default as indexhBQgSvzhrnMeta } from "/Users/air/Projects/EMCI/pages/mentions-legales/index.vue?macro=true";
import { default as indexDOUn7jqIXOMeta } from "/Users/air/Projects/EMCI/pages/offre-emploi/index.vue?macro=true";
import { default as _91idC_93CjIWDxe1cvMeta } from "/Users/air/Projects/EMCI/pages/offre-emploi/offres/[idC].vue?macro=true";
import { default as indexpf8jrGjcE4Meta } from "/Users/air/Projects/EMCI/pages/offre-emploi/offres/index.vue?macro=true";
import { default as indexUey8uGQx1XMeta } from "/Users/air/Projects/EMCI/pages/organisme-formation/index.vue?macro=true";
import { default as indexyCVKQLQplRMeta } from "/Users/air/Projects/EMCI/pages/preparez-votre-formation/index.vue?macro=true";
import { default as presentation61vmktVcDpMeta } from "/Users/air/Projects/EMCI/pages/presentation.vue?macro=true";
import { default as indexoghs5upXceMeta } from "/Users/air/Projects/EMCI/pages/qualite-vie-condition-travail/audit-social/index.vue?macro=true";
import { default as index2HHvnDHpZyMeta } from "/Users/air/Projects/EMCI/pages/qualite-vie-condition-travail/gap/index.vue?macro=true";
import { default as indexo5CqNpMyoLMeta } from "/Users/air/Projects/EMCI/pages/qualite-vie-condition-travail/mediation/index.vue?macro=true";
import { default as index2viC617eH0Meta } from "/Users/air/Projects/EMCI/pages/qualite-vie-condition-travail/prevention-rps/index.vue?macro=true";
import { default as indexfznz7bC5fcMeta } from "/Users/air/Projects/EMCI/pages/qualite-vie-condition-travail/supervision/index.vue?macro=true";
import { default as indextFvOO2VqkvMeta } from "/Users/air/Projects/EMCI/pages/recrutement/approche-directe/index.vue?macro=true";
import { default as indexYXHXN44gH8Meta } from "/Users/air/Projects/EMCI/pages/recrutement/assessment/index.vue?macro=true";
import { default as indexjBcLxs8cI1Meta } from "/Users/air/Projects/EMCI/pages/recrutement/evaluation-candidat/index.vue?macro=true";
import { default as indexvNRbJ2dIEbMeta } from "/Users/air/Projects/EMCI/pages/recrutement/recrutement/index.vue?macro=true";
import { default as indexsrimGe7ietMeta } from "/Users/air/Projects/EMCI/pages/ressources-humaines-rse/index.vue?macro=true";
import { default as indexvykwTGm59UMeta } from "/Users/air/Projects/EMCI/pages/sessions/index.vue?macro=true";
import { default as indexdjZqyRT4aWMeta } from "/Users/air/Projects/EMCI/pages/soft-skills/index.vue?macro=true";
import { default as indexcezHIICgQiMeta } from "/Users/air/Projects/EMCI/pages/transition-professionnelle/activ-projet/index.vue?macro=true";
import { default as indexUFFc0GgB8NMeta } from "/Users/air/Projects/EMCI/pages/transition-professionnelle/bilan-retraite/index.vue?macro=true";
import { default as index2W81WMErplMeta } from "/Users/air/Projects/EMCI/pages/transition-professionnelle/index.vue?macro=true";
import { default as indexIjzOPHz7scMeta } from "/Users/air/Projects/EMCI/pages/transition-professionnelle/outplacement/index.vue?macro=true";
export default [
  {
    name: _404dHtdFZ0cdIMeta?.name ?? "404",
    path: _404dHtdFZ0cdIMeta?.path ?? "/404",
    meta: _404dHtdFZ0cdIMeta || {},
    alias: _404dHtdFZ0cdIMeta?.alias || [],
    redirect: _404dHtdFZ0cdIMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _91titleA_93_45_91idA_93oECcRJDOEuMeta?.name ?? "actualites-titleA-idA",
    path: _91titleA_93_45_91idA_93oECcRJDOEuMeta?.path ?? "/actualites/:titleA()-:idA()",
    meta: _91titleA_93_45_91idA_93oECcRJDOEuMeta || {},
    alias: _91titleA_93_45_91idA_93oECcRJDOEuMeta?.alias || [],
    redirect: _91titleA_93_45_91idA_93oECcRJDOEuMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/actualites/[titleA]-[idA].vue").then(m => m.default || m)
  },
  {
    name: indexmohN8whQqyMeta?.name ?? "actualites",
    path: indexmohN8whQqyMeta?.path ?? "/actualites",
    meta: indexmohN8whQqyMeta || {},
    alias: indexmohN8whQqyMeta?.alias || [],
    redirect: indexmohN8whQqyMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/actualites/index.vue").then(m => m.default || m)
  },
  {
    name: indexH9tYCkiSiPMeta?.name ?? "bilan_competences",
    path: indexH9tYCkiSiPMeta?.path ?? "/bilan_competences",
    meta: indexH9tYCkiSiPMeta || {},
    alias: indexH9tYCkiSiPMeta?.alias || [],
    redirect: indexH9tYCkiSiPMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/bilan_competences/index.vue").then(m => m.default || m)
  },
  {
    name: index3S8ZaVGDi8Meta?.name ?? "bilan_competences-nos_centres",
    path: index3S8ZaVGDi8Meta?.path ?? "/bilan_competences/nos_centres",
    meta: index3S8ZaVGDi8Meta || {},
    alias: index3S8ZaVGDi8Meta?.alias || [],
    redirect: index3S8ZaVGDi8Meta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/bilan_competences/nos_centres/index.vue").then(m => m.default || m)
  },
  {
    name: indexLBz9lz85y0Meta?.name ?? "conseil_rh-entretien_annuel_professionnel",
    path: indexLBz9lz85y0Meta?.path ?? "/conseil_rh/entretien_annuel_professionnel",
    meta: indexLBz9lz85y0Meta || {},
    alias: indexLBz9lz85y0Meta?.alias || [],
    redirect: indexLBz9lz85y0Meta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/conseil_rh/entretien_annuel_professionnel/index.vue").then(m => m.default || m)
  },
  {
    name: indexvMavDzZDLdMeta?.name ?? "conseil_rh-gepp",
    path: indexvMavDzZDLdMeta?.path ?? "/conseil_rh/gepp",
    meta: indexvMavDzZDLdMeta || {},
    alias: indexvMavDzZDLdMeta?.alias || [],
    redirect: indexvMavDzZDLdMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/conseil_rh/gepp/index.vue").then(m => m.default || m)
  },
  {
    name: indexq0RQ2ACBOYMeta?.name ?? "conseil_rh-marque_employeur",
    path: indexq0RQ2ACBOYMeta?.path ?? "/conseil_rh/marque_employeur",
    meta: indexq0RQ2ACBOYMeta || {},
    alias: indexq0RQ2ACBOYMeta?.alias || [],
    redirect: indexq0RQ2ACBOYMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/conseil_rh/marque_employeur/index.vue").then(m => m.default || m)
  },
  {
    name: indexvN287DYUDXMeta?.name ?? "conseil_rh-obligations_legales",
    path: indexvN287DYUDXMeta?.path ?? "/conseil_rh/obligations_legales",
    meta: indexvN287DYUDXMeta || {},
    alias: indexvN287DYUDXMeta?.alias || [],
    redirect: indexvN287DYUDXMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/conseil_rh/obligations_legales/index.vue").then(m => m.default || m)
  },
  {
    name: indexfXbaWwtpOUMeta?.name ?? "conseil_rh-pcrh",
    path: indexfXbaWwtpOUMeta?.path ?? "/conseil_rh/pcrh",
    meta: indexfXbaWwtpOUMeta || {},
    alias: indexfXbaWwtpOUMeta?.alias || [],
    redirect: indexfXbaWwtpOUMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/conseil_rh/pcrh/index.vue").then(m => m.default || m)
  },
  {
    name: indexmFdL6yKwYlMeta?.name ?? "contactez-nous",
    path: indexmFdL6yKwYlMeta?.path ?? "/contactez-nous",
    meta: indexmFdL6yKwYlMeta || {},
    alias: indexmFdL6yKwYlMeta?.alias || [],
    redirect: indexmFdL6yKwYlMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/contactez-nous/index.vue").then(m => m.default || m)
  },
  {
    name: cookiesss7r5URXDyXMMeta?.name ?? "cookiesss",
    path: cookiesss7r5URXDyXMMeta?.path ?? "/cookiesss",
    meta: cookiesss7r5URXDyXMMeta || {},
    alias: cookiesss7r5URXDyXMMeta?.alias || [],
    redirect: cookiesss7r5URXDyXMMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/cookiesss.vue").then(m => m.default || m)
  },
  {
    name: index3dlahpNIjQMeta?.name ?? "equipe-bilan-competences",
    path: index3dlahpNIjQMeta?.path ?? "/equipe-bilan-competences",
    meta: index3dlahpNIjQMeta || {},
    alias: index3dlahpNIjQMeta?.alias || [],
    redirect: index3dlahpNIjQMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/equipe-bilan-competences/index.vue").then(m => m.default || m)
  },
  {
    name: indexKLybyXw6PPMeta?.name ?? "equipe",
    path: indexKLybyXw6PPMeta?.path ?? "/equipe",
    meta: indexKLybyXw6PPMeta || {},
    alias: indexKLybyXw6PPMeta?.alias || [],
    redirect: indexKLybyXw6PPMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/equipe/index.vue").then(m => m.default || m)
  },
  {
    name: indexqkbRkM2wFRMeta?.name ?? "formulaire-reclamation",
    path: indexqkbRkM2wFRMeta?.path ?? "/formulaire-reclamation",
    meta: indexqkbRkM2wFRMeta || {},
    alias: indexqkbRkM2wFRMeta?.alias || [],
    redirect: indexqkbRkM2wFRMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/formulaire-reclamation/index.vue").then(m => m.default || m)
  },
  {
    name: index167DsKZ6tGMeta?.name ?? "fr",
    path: index167DsKZ6tGMeta?.path ?? "/fr",
    meta: index167DsKZ6tGMeta || {},
    alias: index167DsKZ6tGMeta?.alias || [],
    redirect: index167DsKZ6tGMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/fr/index.vue").then(m => m.default || m)
  },
  {
    name: indexcW5UqQae4XMeta?.name ?? "index",
    path: indexcW5UqQae4XMeta?.path ?? "/",
    meta: indexcW5UqQae4XMeta || {},
    alias: indexcW5UqQae4XMeta?.alias || [],
    redirect: indexcW5UqQae4XMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexH5m0zDvIkiMeta?.name ?? "leadership-management",
    path: indexH5m0zDvIkiMeta?.path ?? "/leadership-management",
    meta: indexH5m0zDvIkiMeta || {},
    alias: indexH5m0zDvIkiMeta?.alias || [],
    redirect: indexH5m0zDvIkiMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/leadership-management/index.vue").then(m => m.default || m)
  },
  {
    name: indexUo0fj3d3eHMeta?.name ?? "management-accompagnement_codir",
    path: indexUo0fj3d3eHMeta?.path ?? "/management/accompagnement_codir",
    meta: indexUo0fj3d3eHMeta || {},
    alias: indexUo0fj3d3eHMeta?.alias || [],
    redirect: indexUo0fj3d3eHMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/management/accompagnement_codir/index.vue").then(m => m.default || m)
  },
  {
    name: indexinMpEVHefiMeta?.name ?? "management-co_developpement",
    path: indexinMpEVHefiMeta?.path ?? "/management/co_developpement",
    meta: indexinMpEVHefiMeta || {},
    alias: indexinMpEVHefiMeta?.alias || [],
    redirect: indexinMpEVHefiMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/management/co_developpement/index.vue").then(m => m.default || m)
  },
  {
    name: indexKBihwFAi24Meta?.name ?? "management-coaching_professionnel",
    path: indexKBihwFAi24Meta?.path ?? "/management/coaching_professionnel",
    meta: indexKBihwFAi24Meta || {},
    alias: indexKBihwFAi24Meta?.alias || [],
    redirect: indexKBihwFAi24Meta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/management/coaching_professionnel/index.vue").then(m => m.default || m)
  },
  {
    name: indexutVsgMraT4Meta?.name ?? "management-conduite_du_changement",
    path: indexutVsgMraT4Meta?.path ?? "/management/conduite_du_changement",
    meta: indexutVsgMraT4Meta || {},
    alias: indexutVsgMraT4Meta?.alias || [],
    redirect: indexutVsgMraT4Meta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/management/conduite_du_changement/index.vue").then(m => m.default || m)
  },
  {
    name: indexMYh0BlP7dZMeta?.name ?? "management-team_building",
    path: indexMYh0BlP7dZMeta?.path ?? "/management/team_building",
    meta: indexMYh0BlP7dZMeta || {},
    alias: indexMYh0BlP7dZMeta?.alias || [],
    redirect: indexMYh0BlP7dZMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/management/team_building/index.vue").then(m => m.default || m)
  },
  {
    name: indexhBQgSvzhrnMeta?.name ?? "mentions-legales",
    path: indexhBQgSvzhrnMeta?.path ?? "/mentions-legales",
    meta: indexhBQgSvzhrnMeta || {},
    alias: indexhBQgSvzhrnMeta?.alias || [],
    redirect: indexhBQgSvzhrnMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/mentions-legales/index.vue").then(m => m.default || m)
  },
  {
    name: indexDOUn7jqIXOMeta?.name ?? "offre-emploi",
    path: indexDOUn7jqIXOMeta?.path ?? "/offre-emploi",
    meta: indexDOUn7jqIXOMeta || {},
    alias: indexDOUn7jqIXOMeta?.alias || [],
    redirect: indexDOUn7jqIXOMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/offre-emploi/index.vue").then(m => m.default || m)
  },
  {
    name: _91idC_93CjIWDxe1cvMeta?.name ?? "offre-emploi-offres-idC",
    path: _91idC_93CjIWDxe1cvMeta?.path ?? "/offre-emploi/offres/:idC()",
    meta: _91idC_93CjIWDxe1cvMeta || {},
    alias: _91idC_93CjIWDxe1cvMeta?.alias || [],
    redirect: _91idC_93CjIWDxe1cvMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/offre-emploi/offres/[idC].vue").then(m => m.default || m)
  },
  {
    name: indexpf8jrGjcE4Meta?.name ?? "offre-emploi-offres",
    path: indexpf8jrGjcE4Meta?.path ?? "/offre-emploi/offres",
    meta: indexpf8jrGjcE4Meta || {},
    alias: indexpf8jrGjcE4Meta?.alias || [],
    redirect: indexpf8jrGjcE4Meta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/offre-emploi/offres/index.vue").then(m => m.default || m)
  },
  {
    name: indexUey8uGQx1XMeta?.name ?? "organisme-formation",
    path: indexUey8uGQx1XMeta?.path ?? "/organisme-formation",
    meta: indexUey8uGQx1XMeta || {},
    alias: indexUey8uGQx1XMeta?.alias || [],
    redirect: indexUey8uGQx1XMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/organisme-formation/index.vue").then(m => m.default || m)
  },
  {
    name: indexyCVKQLQplRMeta?.name ?? "preparez-votre-formation",
    path: indexyCVKQLQplRMeta?.path ?? "/preparez-votre-formation",
    meta: indexyCVKQLQplRMeta || {},
    alias: indexyCVKQLQplRMeta?.alias || [],
    redirect: indexyCVKQLQplRMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/preparez-votre-formation/index.vue").then(m => m.default || m)
  },
  {
    name: presentation61vmktVcDpMeta?.name ?? "presentation",
    path: presentation61vmktVcDpMeta?.path ?? "/presentation",
    meta: presentation61vmktVcDpMeta || {},
    alias: presentation61vmktVcDpMeta?.alias || [],
    redirect: presentation61vmktVcDpMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/presentation.vue").then(m => m.default || m)
  },
  {
    name: indexoghs5upXceMeta?.name ?? "qualite-vie-condition-travail-audit-social",
    path: indexoghs5upXceMeta?.path ?? "/qualite-vie-condition-travail/audit-social",
    meta: indexoghs5upXceMeta || {},
    alias: indexoghs5upXceMeta?.alias || [],
    redirect: indexoghs5upXceMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/qualite-vie-condition-travail/audit-social/index.vue").then(m => m.default || m)
  },
  {
    name: index2HHvnDHpZyMeta?.name ?? "qualite-vie-condition-travail-gap",
    path: index2HHvnDHpZyMeta?.path ?? "/qualite-vie-condition-travail/gap",
    meta: index2HHvnDHpZyMeta || {},
    alias: index2HHvnDHpZyMeta?.alias || [],
    redirect: index2HHvnDHpZyMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/qualite-vie-condition-travail/gap/index.vue").then(m => m.default || m)
  },
  {
    name: indexo5CqNpMyoLMeta?.name ?? "qualite-vie-condition-travail-mediation",
    path: indexo5CqNpMyoLMeta?.path ?? "/qualite-vie-condition-travail/mediation",
    meta: indexo5CqNpMyoLMeta || {},
    alias: indexo5CqNpMyoLMeta?.alias || [],
    redirect: indexo5CqNpMyoLMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/qualite-vie-condition-travail/mediation/index.vue").then(m => m.default || m)
  },
  {
    name: index2viC617eH0Meta?.name ?? "qualite-vie-condition-travail-prevention-rps",
    path: index2viC617eH0Meta?.path ?? "/qualite-vie-condition-travail/prevention-rps",
    meta: index2viC617eH0Meta || {},
    alias: index2viC617eH0Meta?.alias || [],
    redirect: index2viC617eH0Meta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/qualite-vie-condition-travail/prevention-rps/index.vue").then(m => m.default || m)
  },
  {
    name: indexfznz7bC5fcMeta?.name ?? "qualite-vie-condition-travail-supervision",
    path: indexfznz7bC5fcMeta?.path ?? "/qualite-vie-condition-travail/supervision",
    meta: indexfznz7bC5fcMeta || {},
    alias: indexfznz7bC5fcMeta?.alias || [],
    redirect: indexfznz7bC5fcMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/qualite-vie-condition-travail/supervision/index.vue").then(m => m.default || m)
  },
  {
    name: indextFvOO2VqkvMeta?.name ?? "recrutement-approche-directe",
    path: indextFvOO2VqkvMeta?.path ?? "/recrutement/approche-directe",
    meta: indextFvOO2VqkvMeta || {},
    alias: indextFvOO2VqkvMeta?.alias || [],
    redirect: indextFvOO2VqkvMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/recrutement/approche-directe/index.vue").then(m => m.default || m)
  },
  {
    name: indexYXHXN44gH8Meta?.name ?? "recrutement-assessment",
    path: indexYXHXN44gH8Meta?.path ?? "/recrutement/assessment",
    meta: indexYXHXN44gH8Meta || {},
    alias: indexYXHXN44gH8Meta?.alias || [],
    redirect: indexYXHXN44gH8Meta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/recrutement/assessment/index.vue").then(m => m.default || m)
  },
  {
    name: indexjBcLxs8cI1Meta?.name ?? "recrutement-evaluation-candidat",
    path: indexjBcLxs8cI1Meta?.path ?? "/recrutement/evaluation-candidat",
    meta: indexjBcLxs8cI1Meta || {},
    alias: indexjBcLxs8cI1Meta?.alias || [],
    redirect: indexjBcLxs8cI1Meta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/recrutement/evaluation-candidat/index.vue").then(m => m.default || m)
  },
  {
    name: indexvNRbJ2dIEbMeta?.name ?? "recrutement-recrutement",
    path: indexvNRbJ2dIEbMeta?.path ?? "/recrutement/recrutement",
    meta: indexvNRbJ2dIEbMeta || {},
    alias: indexvNRbJ2dIEbMeta?.alias || [],
    redirect: indexvNRbJ2dIEbMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/recrutement/recrutement/index.vue").then(m => m.default || m)
  },
  {
    name: indexsrimGe7ietMeta?.name ?? "ressources-humaines-rse",
    path: indexsrimGe7ietMeta?.path ?? "/ressources-humaines-rse",
    meta: indexsrimGe7ietMeta || {},
    alias: indexsrimGe7ietMeta?.alias || [],
    redirect: indexsrimGe7ietMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/ressources-humaines-rse/index.vue").then(m => m.default || m)
  },
  {
    name: indexvykwTGm59UMeta?.name ?? "sessions",
    path: indexvykwTGm59UMeta?.path ?? "/sessions",
    meta: indexvykwTGm59UMeta || {},
    alias: indexvykwTGm59UMeta?.alias || [],
    redirect: indexvykwTGm59UMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/sessions/index.vue").then(m => m.default || m)
  },
  {
    name: indexdjZqyRT4aWMeta?.name ?? "soft-skills",
    path: indexdjZqyRT4aWMeta?.path ?? "/soft-skills",
    meta: indexdjZqyRT4aWMeta || {},
    alias: indexdjZqyRT4aWMeta?.alias || [],
    redirect: indexdjZqyRT4aWMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/soft-skills/index.vue").then(m => m.default || m)
  },
  {
    name: indexcezHIICgQiMeta?.name ?? "transition-professionnelle-activ-projet",
    path: indexcezHIICgQiMeta?.path ?? "/transition-professionnelle/activ-projet",
    meta: indexcezHIICgQiMeta || {},
    alias: indexcezHIICgQiMeta?.alias || [],
    redirect: indexcezHIICgQiMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/transition-professionnelle/activ-projet/index.vue").then(m => m.default || m)
  },
  {
    name: indexUFFc0GgB8NMeta?.name ?? "transition-professionnelle-bilan-retraite",
    path: indexUFFc0GgB8NMeta?.path ?? "/transition-professionnelle/bilan-retraite",
    meta: indexUFFc0GgB8NMeta || {},
    alias: indexUFFc0GgB8NMeta?.alias || [],
    redirect: indexUFFc0GgB8NMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/transition-professionnelle/bilan-retraite/index.vue").then(m => m.default || m)
  },
  {
    name: index2W81WMErplMeta?.name ?? "transition-professionnelle",
    path: index2W81WMErplMeta?.path ?? "/transition-professionnelle",
    meta: index2W81WMErplMeta || {},
    alias: index2W81WMErplMeta?.alias || [],
    redirect: index2W81WMErplMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/transition-professionnelle/index.vue").then(m => m.default || m)
  },
  {
    name: indexIjzOPHz7scMeta?.name ?? "transition-professionnelle-outplacement",
    path: indexIjzOPHz7scMeta?.path ?? "/transition-professionnelle/outplacement",
    meta: indexIjzOPHz7scMeta || {},
    alias: indexIjzOPHz7scMeta?.alias || [],
    redirect: indexIjzOPHz7scMeta?.redirect,
    component: () => import("/Users/air/Projects/EMCI/pages/transition-professionnelle/outplacement/index.vue").then(m => m.default || m)
  }
]